import { render } from "./tabPanel.vue?vue&type=template&id=f7893048&scoped=true"
import script from "./tabPanel.vue?vue&type=script&lang=js"
export * from "./tabPanel.vue?vue&type=script&lang=js"

import "./tabPanel.vue?vue&type=style&index=0&id=f7893048&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1446831496/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7893048"]])

export default __exports__